import {
    Box,
    Typography,
} from '@mui/material'
import {Image} from 'antd'
import BG from '../../../assets//personal-loan/download-bg.jpg'
import AppGallery from '../../../assets/download/download_appgallery.png'
import GooglePlay from '../../../assets/download/download_googleplay.png'
import AppStore from '../../../assets/download/download_appstore.png'
import { GOOGLE_PLAY_STORE_LINK, APP_STORE_LINK, APP_GALLERY_LINK } from '../../../common/config'
import { useTranslation } from 'react-i18next'

export const SMDownload: React.FC = () => {

    const { t } = useTranslation()

    const clickGooglePlay = () => {
        window.open(GOOGLE_PLAY_STORE_LINK)
    }

    // ======================= AppStore
    const clickAppStore = () => {
        window.open(APP_STORE_LINK)
    }

    // ======================= AppGallery
    const clickAppGallery = () => {
        window.open(APP_GALLERY_LINK)
    }

    // ======================= VIEWS
    return (
        <Box
            sx={{
                width: '100%',
                paddingLeft: '72px',
                paddingRight: '72px',
                paddingTop: '60px',
                paddingBottom: '60px'
            }}
        >
            <Box sx={{ 
                position: 'relative',
                objectFit: 'cover',
                backgroundSize: 'cover',
                backgroundPosition: 'center',
                backgroundRepeat: 'no-repeat',
                width: '100%',
                height: '504px',
                backgroundImage: `url(${BG})`,
                borderRadius: '10px',
                }}>
            <Box sx={{
                position: 'absolute', 
                left: 0, 
                top: 0, 
                right: 0, 
                bottom: 0, 
                borderRadius: '10px',
                backgroundColor: 'rgba(0,0,0,0.3)', 
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                justifyContent: 'center',
                paddingLeft: '120px',
                paddingRight: '120px',
            }}>
                <Typography fontSize={16} fontWeight={500} color={'#FFFFFF'} textAlign={'center'}>
                    {t('t250')}
                </Typography>

                <Typography fontSize={32} fontWeight={700} color={'#FFFFFF'} paddingTop={'30px'} textAlign={'center'}>
                    {t('t251')}
                </Typography>

                <Typography fontSize={16} fontWeight={400} color={'#F0F0F0'} paddingTop={'30px'} textAlign={'center'} paddingLeft={'100px'} paddingRight={'100px'}>
                    {t('t252')}
                </Typography>

                <Box sx={{
                    display: 'flex',
                    flexDirection: 'row',
                    paddingTop: '30px'
                }}>
                    <Box
                        onClick={clickGooglePlay}
                        sx={{
                            cursor: 'pointer',
                        }}>
                        <Image src={GooglePlay} width={150} height={50} alt='' preview={false}></Image>
                    </Box>

                    <Box sx={{
                        width: '80px'
                    }}></Box>

                    <Box
                        onClick={clickAppStore}
                        sx={{
                            cursor: 'pointer',
                        }}>
                        <Image src={AppStore} width={150} height={50} alt='' preview={false}></Image>
                    </Box>

                    <Box sx={{
                        width: '80px'
                    }}></Box>

                    <Box
                        onClick={clickAppGallery}
                        sx={{
                            cursor: 'pointer',
                        }}>
                        <Image src={AppGallery} width={150} height={50} alt='' preview={false}></Image>
                    </Box>
                </Box>
            </Box>
            </Box>

        </Box >
    )
}

// ======================= EXPORT
export default SMDownload
